export default "__VITE_ASSET__DWHTqzTB__"